/**
 * @generated SignedSource<<d7d5a177408caa59766a3f8397a41838>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LegacyBridgeContentFragment_content$data = {
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly space: {
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly type: string | null;
  } | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly version: {
    readonly number: number | null;
  } | null;
  readonly " $fragmentType": "LegacyBridgeContentFragment_content";
};
export type LegacyBridgeContentFragment_content$key = {
  readonly " $data"?: LegacyBridgeContentFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"LegacyBridgeContentFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "type"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "LegacyBridgeContentFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        (v1/*: any*/)
      ]
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "2eef49a2bb90d09a50476b9756a138e0";

export default node;
